import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useStateGetter } from "./statehooks/UseStateGettersHook";
import { useStateSetter } from "./statehooks/UseStateSettersHook";
import {
  onAddDeptUser,
  onGetDeptUsers,
  onGetOrgDept,
} from "../services/department";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

const useDeptHook = () => {
  const [AllOrgDepts, setAllOrgDept] = useState<any[]>([]);
  const { config, selectedDept, SelectedOrg } = useStateGetter();
  const [deptUsers, setdeptUsers] = useState([]);
  const { setLoading } = useStateSetter();

    const {orgid}=useParams()
  

  const getDeptUsers = async () => {
    setLoading(true);
    try {
      var response = await onGetDeptUsers(selectedDept.id??orgid, config);
      let users: any = [];
      response.data.map((i: any) => {
        users.push(i.user);
      });
      setdeptUsers(users);
      setLoading(false);
    } catch (e: any) {
      console.log(e);
    //  toast.error(e);
      setLoading(false);
    }
  };

  const onAddUsertoDept = async (userID: any) => {
    let postdata = {
      userID: userID,
      deptID: selectedDept.id,
      organizationID: SelectedOrg.id,
    };
    setLoading(true);
    try {
      var response = await onAddDeptUser(postdata, config);
      setLoading(false);
      toast(response.message);
    } catch (e: any) {
      toast.error(e);
      console.log(e);
      setLoading(false);
    }
  };
  const getorgAllDepts = async () => {
    setLoading(true);
    try {
      var response = await onGetOrgDept(SelectedOrg.id, config);
      setAllOrgDept(response.data);
      setLoading(false);
    } catch (e: any) {
      console.log(e);
      //toast.error(e)
      setLoading(false);
    }
  };
  const refresh =async ()=>{


    await getorgAllDepts()
  }
  useEffect(() => {
    getorgAllDepts();
    getDeptUsers();
  }, [selectedDept.id]);
  return { AllOrgDepts,refresh, deptUsers, onAddUsertoDept };
};


export { useDeptHook };
